


































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

const STATE_FALSE = 0;
const STATE_TRUE = 1;
const STATE_NULL = 2;
const states = [STATE_FALSE, STATE_TRUE, STATE_NULL];

@Component({})
export default class SearchCheckbox extends Vue {
  @Prop({})
  filter!: any;

  @Prop({ type: Boolean, default: false })
  slider!: boolean;

  @Prop({ default: "" })
  customLabel!: string;

  _model: any = null;
  isIndeterminate = false;
  stateCounter = 0;

  sliderValue = false;

  get label() {
    if (this.customLabel) {
      return this.customLabel;
    }
    if (this.filter.field === "active") {
      return this.$t("active");
    }
    if (
      this.filter.type === "NOT_PRESENCE" &&
      this.filter.display &&
      this.filter.display.length > 0
    ) {
      return this.$t(this.filter.display);
    }
    return this.$t(this.filter.field);
  }

  created() {
    if (this.filter.defaultValue) {
      this.isIndeterminate = false;
      this._model = this.filter.defaultValue === "true";
      this.stateCounter =
        this.filter.defaultValue === "true" ? STATE_TRUE : STATE_FALSE;
    } else {
      this.isIndeterminate = true;
      this._model = null;
      this.stateCounter = 0;
    }

    if (this.slider) {
      this.sliderValue = !!this._model;
    }

    this.$emit("update:model", this._model);
  }

  handleChange(event: any) {
    if (this.stateCounter === STATE_NULL) {
      this.isIndeterminate = true;
      this._model = null;
    } else {
      this.isIndeterminate = false;
      this._model = event;
    }

    this.$emit("update:model", this._model);

    this.stateCounter = (this.stateCounter + 1) % states.length;
  }

  onSlide(value: boolean) {
    this._model = value;
    this.$emit("update:model", value);
  }

  @Watch("$attrs.model")
  resetCheckbox() {
    if (this.$attrs.model == null) {
      this.isIndeterminate = true;
      this.stateCounter = STATE_FALSE;
      this._model = null;
    } else {
      this.isIndeterminate = false;
      this.stateCounter = this.$attrs.model ? STATE_TRUE : STATE_NULL;
      this._model = this.$attrs.model;
    }

    if (this.slider) {
      this.sliderValue = !!this._model;
    }
  }
}
